import UtilizationCard from './UtilizationCard';
import UtilizationCardDetails from './UtilizationCardDetails';
import UtilizationCardDetailsCount from './UtilizationCardDetailsCount';
import UtilizationCardDetailsDesc from './UtilizationCardDetailsDesc';
import UtilizationCardDetailsLine1 from './UtilizationCardDetailsLine1';
import UtilizationCardDetailsLine2 from './UtilizationCardDetailsLine2';

UtilizationCard.Details = UtilizationCardDetails;
UtilizationCard.DetailsCount = UtilizationCardDetailsCount;
UtilizationCard.DetailsDesc = UtilizationCardDetailsDesc;
UtilizationCard.DetailsLine1 = UtilizationCardDetailsLine1;
UtilizationCard.DetailsLine2 = UtilizationCardDetailsLine2;

export { UtilizationCard, UtilizationCardDetails, UtilizationCardDetailsCount, UtilizationCardDetailsDesc, UtilizationCardDetailsLine1, UtilizationCardDetailsLine2 };


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Cards/UtilizationTrendCard/index.js
// module id = 636
// module chunks = 0